export default {
    "de": {
        "Hello!": "Hallo!",
        "Verify Email Address Subject": "Bitte gleich bestätigen: Ihre Registrierung auf bdew-heizkostenvergleich.de",
        "Verify Email Address": "Bitte hier klicken, um zu bestätigen",
        "Please click the button below to verify your email address.": "Bitte klicken Sie den folgenden Link an, um Ihre Anmeldung zu bestätigen:",
        "If you did not create an account, no further action is required.": "Sollten Sie diese Anfrage nicht selbst initiiert haben, bitten wir Sie, diese Nachricht zu ignorieren und den Link nicht zu bestätigen. Ohne Bestätigung werden die eingetragenen Daten automatisch nach 24 Stunden gelöscht.",
        "If you’re having trouble clicking the \"{actionText}\" button, copy and paste the URL below\ninto your web browser:": "Sollten Sie Probleme haben, den \"{actionText}\" Button anzuklicken, kopieren Sie folgenden Link in Ihren Browser:",
        "Regards": "Mit freundlichen Grüßen\nIhr Team vom",
        "result": {
            "verbrauchsgebundene_kosten": "Verbrauchsgebundene Kosten",
            "spez_nutzenergiebedarf_kWh_m2_a": "spez. Nutzenergiebedarf ",
            "nutzenergiebedarf_kWh_a": "Nutzenergiebedarf",
            "waermeenergiebedarf_kWh_a": "Wärmeenergiebedarf",
            "spez_primaerenergiebedarf_kWh_m2_a": "spez. Primärenergiebedarf ",
            "primaerenergetische_anlagenaufwandszahl": "primärenergetische Anlagenaufwandszahl",
            "energieeffizienzklasse_endenergiebedarf": "Energieeffizienzklasse Endenergiebedarf",
            "jahresendenergiebedarf": "Jahresendenergiebedarf",
            "jahresendenergiebedarf_1WE_kWhHi": "1.WE",
            "jahresendenergiebedarf_1WE_kWhHs": "1.WE",
            "jahresendenergiebedarf_2WE_kWhHi": "2.WE",
            "hilfsenergiebedarf_kWh": "Hilfsenergiebedarf",
            "arbeitspreis": "Arbeitspreis",
            "arbeitspreis_1WE_euro_kWh": "1.WE",
            "arbeitspreis_2WE_euro_kWh": "2.WE",
            "arbeitspreis_hilfsenergie_euro_kWh": "Hilfsenergie",
            "jahresenergiekosten": "Jahresenergiekosten",
            "jahresenergiekosten_1WE_euro_kWh": "1.WE",
            "jahresenergiekosten_2WE_euro_kWh": "2.WE",
            "notwendige_lagermenge_la_ta": "notwendige Lagermenge",
            "zinskosten_gelagerte_brennstoffe_euro_a": "Zinskosten gelagerte Brennstoffe",
            "grundpreis_euro_a": "Grundpreis",
            "kosten_hilfsenergie_euro_a": "Kosten Hilfsenergie",
            "summe_heizung_twe": "Summe Heizung / TWE",
            "stromverguetung_und_eingesparte_strombezugskosten": "Stromvergütung + eingesparte Strombezugskosten",
            "rueckverguetung_energiesteuer": "Rückvergütung Energiesteuer",
            "summe_euro_a": "Summe",
            "investitionen": "Investitionen",
            "demontage": "Demontage",
            "waermeerzeuger_regelung": "Wärmeerzeuger / Regelung",
            "heizflaechen_geringinvestive_massnahmen": "Heizflächen / geringinvestive Maßnahmen",
            "schornstein_und_sonst_baukosten": "Schornstein / sonst. Baukosten",
            "hausanschluss": "Hausanschluss",
            "kosten_brennstofflagerung": "Brennstofflagerung",
            "kosten_gas_elektroinstallation": "Gas- / Elektroinstallation",
            "summe_investitionskosten": "Summe Heizung / TWE",
            "kapitalgebundene_kosten": "Kapitalgebundene Kosten",
            "heizflaechen_und_geringinvestive_massnahmen": "Heizflächen / geringinvestive Maßnahmen",
            "summe_kapitalgebundene_kosten": "Summe",
            "foerderung": "Förderung",
            "betriebsgebundene_kosten": "Betriebsgebundene Kosten",
            "wartung_schornsteinfegergebuehren": "Wartung / Schornsteinfegergebühren",
            "instandhaltungskosten": "Instandhaltungskosten",
            "heizkostenabrechnung": "Heizkostenabrechnung",
            "versicherung": "Versicherung",
            "summe_betriebsgebundene_kosten": "Summe",
            "jahres_gesamtkosten": "Jahresgesamtkosten",
            "summe_jahres_gesamtkosten_heizung_twe": "Summe Heizung / TWE",
            "summe_jahres_gesamtkosten": "Summe",
            "kosten_index": "Kostenindex",
            "thg_emissionen": "THG-Emissionen",
            "thg_emissionen_index": "THG-Emissionen Index",
            "summe_thg_emissionen": "Summe",
            "thg_nutzflaechenbezogen": "nutzflächenbezogen",
            "thg_einsparung": "Einsparung",
            "lueftungsanlage": "Lüftungsanlage",
            "heizflaechen_leitungssystem": "Heizflächen / Leitungssystem"
        },
        "calculator": {
            "altbau": "Altbau",
            "neubau": "Neubau",
            "6-FH": "6-Familienhaus",
            "EFH": "Einfamilienhaus",
            "IST_01": "Gas-Altkessel",
            "IST_02": "Öl-Altkessel",
            "change_IST_01": "Kesseltausch Gas zu...",
            "change_IST_02": "Kesseltausch Öl zu...",
            "rate_IST_01": "Gasverbrauch (Bezug: Brennwert)",
            "rate_IST_02": "Heizölverbrauch",
            "change_EH55": "Effizienzhaus 55",
            "change_mindest": "Baulicher Mindeststandard Gebäudeenergiegesetz (GEG)",
            "EH55": "Effizienzhaus 55",
            "mindest": "Mindestwärmeschutz",
            "type_zentraler_twe": "mit zentraler Trinkwassererwärmung",
            "type_dezentraler_twe": "mit dezentraler Trinkwassererwärmung",
            "variation_altbau": "Sanierungsvariante",
            "variation_neubau": "Anforderungsniveau",
            "tt_allgemeine_objektdaten": "Diese Angaben sind optional. Zur Speicherung sind Angaben im Feld Objektbezeichnung erforderlich.",
            "tt_waermeschutzniveau_EFH": "Platzhalter waermeschutzniveau_EFH",
            "tt_waermeschutzniveau_6-FH": "Platzhalter waermeschutzniveau_6-FH",
            "tt_endenergiebedarf": "Der hinterlegte Endenergiebedarf (die bezogene Menge an Gas oder Heizöl) wurde für ein konkretes Gebäude (siehe Erläuterungen) ermittelt. Über Zu- oder Abschläge können die Energiekennwerte in einem Bereich von -30 Prozent bis +30 Prozent näherungsweise an den tatsächlichen Verbrauch des konkreten Hauses angepasst werden.",
            "tt_energietraeger": "Zum Teil unterscheiden sich die Energiepreise durch unterschiedliche Abnahmemengen gleicher Energieträger bei den betrachteten Anlagensystemen. Pellet Sackware sind die Energiepreise für das System mit Pelletofen.",
            "tt_zinssatz": "Die Berechnung der Annuität erfolgt über die Nutzungsdauer und dem Instandsetzungsaufwand der Komponenten entsprechend der Angaben in der VDI 2067 Blatt 1 mit dem hier angegebenen Kalkulationszinssatz. Mit dem angesetzten Kalkulationszinssatz wird unterstellt, dass eine Fremdkapitalfinanzierung erfolgt.",
            "tt_photovoltaikanlagen": "Platzhalter tt_photovoltaikanlagen",
            "tt_waermeerzeugung": "Platzhalter tt_waermeerzeugung",
            "tt_warmwasserbereitung": "Enthält: Warmwasserspeicher, Durchlauferhitzer und Zubehör \u2028(Warmwasserleitungen sind unter weitere Kosten Anlagentechnik aufgeführt)",
            "tt_weitere_kosten_anlagetechnik": "Platzhalter tt_weitere_kosten_anlagetechnik",
            "tt_hinweise_individualisierung": "Als Berechnungsgrundlage dienen beispielhaft typische Wohngebäude mit verschiedenen Grundannahmen aus dem BDEW-Heizkostenvergleich. Die Berechnungen zielen auf einen möglichst vollständigen Vergleich der Kosten der betrachteten Systeme. Hintergründe und Erläuterungen ergeben sich aus dem BDEW-Heizkostenvergleich (siehe Erläuterungen).",
            "tt_investitionskosten": "Platzhalter tt_investitionskosten",
            "tt_views": "Platzhalter tt_views",
            "tt_waermeerzeugung_altbau": "Enthält: Wärmeerzeugung mit Regelung, Brennstofflagerung, Gas-/Öl- und Elektro-Installation, Schornstein sowie weitere Baukosten; Investitionskosten für PV-Anlage \u2028(Kosten für geringinvestive Maßnahmen und Heizkörper soweit Bestandteil des Systems, sind unter weitere Kosten Anlagentechnik aufgeführt)",
            "tt_waermeerzeugung_neubau": "Enthält: Wärmeerzeugung mit Regelung, Brennstofflagerung, Gas-/Öl- und Elektro-Installation, Schornstein sowie weitere Baukosten; Investitionskosten für PV-Anlage \u2028(Kosten für Lüftungsanlagen, Fußbodenheizung und Heizkörper soweit Bestandteil des Systems, sind unter weitere Kosten Anlagentechnik aufgeführt)",
            "tt_foerderung_altbau": "Enthält: Fördersummen entsprechend BEG (Einzelmaßnahmen und Heizungsoptimierung)<br>Brennstoffzellen erhalten eine Förderung wenn Sie mit Biogas oder grünem Wasserstoff betrieben werden.<br><br>Die hier hinterlegte Förderung kann in Form von €-Beträgen <b>oder</b> %-Satz der anrechenbaren Herstellkosten (gemäß BEG) individuell angepasst werden.",
            "tt_foerderung_neubau": "Enthält den Zuschuss Brennstoffzelle nach KfW 433.",
            "tt_weitere_kosten_anlagetechnik_altbau": "geringinvestive Maßnahmen beinhalten: Dämmung der Verteilleitungen (Heizung und Warmwasser) im Keller, Einbau neuer Thermostatventile, hydraulischer Abgleich sowie Kosten für Heizkörper soweit Bestandteil des Systems",
            "tt_weitere_kosten_anlagetechnik_neubau": "Kosten für Lüftungsanlagen und Warmwasserleitungen sowie Fußbodenheizung und Heizkörper soweit Bestandteil des Systems",
            "tt_waermeschutzniveau_neubau": "Wärmeschutz nach Effizienzhaus-Niveau 55\t, H’<sub>T,vorhanden</sub> = 70 % · H’<sub>T,Referenzgebäude</sub><br><br>Mindestwärmeschutz nach GEG-Referenzgebäude \tH’<sub>T,vorhanden</sub> = H’<sub>T,Referenzgebäude</sub>"
        },
        "default": {
            "surname": "Vorname",
            "firstname": "Vorname",
            "lastname": "Nachname",
            "street and number": "Straße und Hausnummer",
            "street": "Straße und Hausnummer",
            "postcode": "PLZ",
            "email": "E-Mail-Adresse",
            "country": "Land",
            "country_id": "Land",
            "telephone": "Telefon",
            "company": "Unternehmen",
            "city": "Ort",
            "language": "Sprache",
            "password": "Passwort",
            "password_confirm": "Passwort Bestätigung",
            "current_password": "Aktuelles Passwort",
            "new_password": "Neues Passwort",
            "new_password_confirm": "Bestätigung Neues Passwort",
            "new_email": "Neue E-Mail-Adresse",
            "object": "Objektbezeichnung",
            "zip": "PLZ",
            "project_number": "Projekt-Nr.",
            "editor": "Name",
            "date": "Datum",
            "message": "Nachricht",
            "Please click the button below to verify your email address.": "asdasd",
            "Hello!": "Hallo",
            "version": "Version"
        },
        "messages": {
            "Hello!": "Hallo"
        }
    },
    "en": {
        "passwords": {
            "reset": "Your password has been reset!",
            "sent": "We have emailed your password reset link!",
            "throttled": "Please wait before retrying.",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that email address."
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "password": "The provided password is incorrect.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} must only contain letters.",
            "alpha_dash": "The {attribute} must only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} must only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "ends_with": "The {attribute} must end with one of the following: {values}.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} must not be greater than {max}.",
                "file": "The {attribute} must not be greater than {max} kilobytes.",
                "string": "The {attribute} must not be greater than {max} characters.",
                "array": "The {attribute} must not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "multiple_of": "The {attribute} must be a multiple of {value}.",
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "password": "The password is incorrect.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "prohibited": "The {attribute} field is prohibited.",
            "prohibited_if": "The {attribute} field is prohibited when {other} is {value}.",
            "prohibited_unless": "The {attribute} field is prohibited unless {other} is in {values}.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}.",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UUID.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        }
    }
}
